export const excludeSelectedOptions = (options, ownValue, excludedValues = [], getValue = (o) => o) => {
  const excluded = new Set(
    excludedValues.filter((v) => v !== undefined && v !== null && v !== "" && v !== ownValue)
  );
  if (!options?.length || excluded.size === 0) return options || [];
  return options.filter((opt) => !excluded.has(getValue(opt)));
};
